/* Suchmaschine im Browser: Tippfehler, Slang, Artikelnummern, Größe/Sofort/Preis aus Freitext */
(function (root) {
  'use strict';
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/ß/g, 'ss').normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Slang → Alternativen (jede Alternative = Wörter, die alle vorkommen müssen) */
  var SYN = {
    af1: [['air', 'force', '1'], ['af1']], af: [['air', 'force']], aj1: [['jordan', '1']], aj2: [['jordan', '2']],
    aj3: [['jordan', '3']], aj4: [['jordan', '4']], aj5: [['jordan', '5']], aj6: [['jordan', '6']],
    aj11: [['jordan', '11']], aj12: [['jordan', '12']], j1: [['jordan', '1']], j4: [['jordan', '4']],
    nb: [['new', 'balance']], tn: [['air', 'max', 'plus']], am1: [['air', 'max', '1']], am90: [['air', 'max', '90']],
    am95: [['air', 'max', '95']], ye: [['yeezy']], travis: [['travis', 'scott']], ts: [['travis', 'scott']],
    panda: [['panda'], ['black', 'white']], chicago: [['chicago']], bred: [['bred']],
    schwarz: [['black'], ['schwarz']], weiss: [['white'], ['weiss']], grau: [['grey'], ['gray']],
    rot: [['red']], blau: [['blue']], gruen: [['green']], braun: [['brown']], rosa: [['pink']],
    gelb: [['yellow']], lila: [['purple']], beige: [['beige'], ['cream']], creme: [['cream']],
    pulli: [['hoodie'], ['sweatshirt'], ['crewneck']], kapuzenpullover: [['hoodie']], hoodies: [['hoodie']],
    tshirt: [['t', 'shirt'], ['tee']], tee: [['tee'], ['t', 'shirt']], shirt: [['shirt'], ['tee']],
    schlappen: [['slide']], badelatschen: [['slide']], slides: [['slide']], hose: [['pants'], ['sweatpants'], ['shorts']],
    jacke: [['jacket']], muetze: [['beanie'], ['cap']], tasche: [['bag']], rucksack: [['backpack']],
    gazelle: [['gazelle']], sambas: [['samba']], dunks: [['dunk']], kaws: [['kaws']], labubu: [['labubu']]
  };
  var STOP = { schuhe: 1, schuh: 1, sneaker: 1, sneakers: 1, von: 1, der: 1, die: 1, das: 1, und: 1, mit: 1, fuer: 1,
    in: 1, im: 1, ein: 1, eine: 1, suche: 1, suchen: 1, herren: 1, damen: 1, men: 1, women: 1, mens: 1 };
  var KIDS = { gs: 1, kids: 1, kinder: 1, ps: 1, td: 1, junior: 1, grade: 1 };
  var CLOTH = { xxs: 1, xs: 1, s: 1, m: 1, l: 1, xl: 1, xxl: 1, xxxl: 1 };

  var items = [], vocab = Object.create(null), vocabKeys = [], brands = [], ready = false;

  function build(data) {
    var vcount = Object.create(null), bcount = Object.create(null), bname = Object.create(null);
    items = data.map(function (r, i) {
      var t = norm(r[1]), v = norm(r[2]);
      var skus = r[6].map(function (s) { var n = norm(s); return n + ' ' + n.replace(/ /g, ''); });
      var hay = ' ' + t + ' ' + (t.indexOf(v) > -1 ? '' : v + ' ') + skus.join(' ') + ' ';
      t.split(' ').concat(v.split(' ')).forEach(function (w) {
        if (w.length >= 3 && !/\d/.test(w)) vcount[w] = (vcount[w] || 0) + 1;
      });
      bcount[v] = (bcount[v] || 0) + 1;
      if (!bname[v] || r[2] !== r[2].toLowerCase()) bname[v] = bname[v] && bname[v] !== bname[v].toLowerCase() ? bname[v] : r[2];
      return { i: i, r: r, t: t, v: v, hay: hay, sof: r[5].map(String), all: r[10].map(String),
        ntok: t.split(' ').length };
    });
    vocab = vcount; vocabKeys = Object.keys(vcount);
    brands = Object.keys(bcount).map(function (k) { return { key: k, name: bname[k], n: bcount[k] }; })
      .filter(function (b) { return b.key.length > 1; }).sort(function (a, b) { return b.n - a.n; });
    ready = true;
  }

  function dl(a, b, max) { /* Damerau-Levenshtein mit Abbruch */
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var da = [], i, j;
    for (i = 0; i <= a.length; i++) { da[i] = [i]; }
    for (j = 1; j <= b.length; j++) da[0][j] = j;
    for (i = 1; i <= a.length; i++) {
      var rowMin = 99;
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(da[i - 1][j] + 1, da[i][j - 1] + 1, da[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, da[i - 2][j - 2] + 1);
        da[i][j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
    }
    return da[a.length][b.length];
  }

  function hasWord(w) {
    if (vocab[w]) return true;
    for (var i = 0; i < vocabKeys.length; i++) if (vocabKeys[i].indexOf(w) === 0) return true;
    return false;
  }
  function fix(w) {
    var max = w.length >= 8 ? 2 : 1, best = null, bd = 9, bc = 0;
    for (var i = 0; i < vocabKeys.length; i++) {
      var k = vocabKeys[i];
      if (Math.abs(k.length - w.length) > max) continue;
      var d = dl(w, k, max);
      if (d <= max && (d < bd || (d === bd && vocab[k] > bc))) { best = k; bd = d; bc = vocab[k]; }
    }
    return best;
  }

  function parse(q) {
    var oq = String(q || ''), P0 = null, mm = oq.match(/\s(S|M|L)\s*$/);
    if (mm) oq = oq.slice(0, mm.index);
    var raw = ' ' + oq.toLowerCase().replace(/ß/g, 'ss').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ä/g, 'a') + ' ';
    var P = { sizes: [], cloth: [], sofort: false, max: null, terms: [], fixes: [], kids: false, sku: false };
    if (mm) P.cloth.push(mm[1]);
    /* Preis */
    raw = raw.replace(/\s(?:unter|bis|max|maximal|under|below|<)\s*(\d{2,4})\s*(?:€|euro|eur)?(?=\s)/g, function (m, n) { P.max = +n; return ' '; });
    /* Größe: 42, 42.5, 42,5 (35–48) und "gr m" */
    raw = raw.replace(/\s(?:gr\.?|groesse|size|eu)?\s?(3[5-9]|4[0-8])(?:[.,]5)?(?=\s)/g, function (m) {
      var n = m.match(/(3[5-9]|4[0-8])([.,]5)?/); P.sizes.push(n[1] + (n[2] ? '.5' : '')); return ' ';
    });
    raw = raw.replace(/\s(?:gr\.?|groesse|size)\s*(xxs|xs|s|m|l|xl|xxl|xxxl)(?=\s)/g, function (m, s) { P.cloth.push(s.toUpperCase()); return ' '; });
    raw = raw.replace(/\s(xxs|xs|xl|xxl|xxxl)(?=\s)/g, function (m, s) { P.cloth.push(s.toUpperCase()); return ' '; });
    raw = raw.replace(/\s(sofort|express|lieferbar|verfuegbar|vorrätig|vorraetig|instock|in\s+stock)(?=\s)/g, function () { P.sofort = true; return ' '; });
    var words = norm(raw).split(' ').filter(Boolean);
    words.forEach(function (w, idx) {
      if (STOP[w]) return;
      if (KIDS[w]) P.kids = true;
      var term = { w: w, orig: w, alts: SYN[w] || null, fixed: false };
      if (/\d/.test(w) && w.length >= 5 && /[a-z]/.test(w)) P.sku = true;
      if (!term.alts && !/\d/.test(w) && w.length >= 4 && ready && !hasWord(w)) {
        var f = fix(w);
        if (f) { term.w = f; term.fixed = true; P.fixes.push([w, f]); }
      }
      P.terms.push(term);
    });
    return P;
  }

  function tokOk(hay, tok, isLast) {
    if (/^\d+$/.test(tok)) return hay.indexOf(' ' + tok + ' ') > -1;
    return hay.indexOf(' ' + tok) > -1;
  }
  function termOk(it, term) {
    if (term.alts) {
      for (var a = 0; a < term.alts.length; a++) {
        var ok = true;
        for (var k = 0; k < term.alts[a].length; k++) if (!tokOk(it.hay, term.alts[a][k])) { ok = false; break; }
        if (ok) return true;
      }
      return false;
    }
    return tokOk(it.hay, term.w);
  }
  function sizeHit(it, P) {
    var want = P.sizes.concat(P.cloth);
    if (!want.length) return { ok: true, sof: it.sof.length > 0, sizes: [] };
    var have = [], sof = false;
    want.forEach(function (s) {
      var inAll = it.all.some(function (x) { return x.toUpperCase().split(/[ \/]/)[0] === s.toUpperCase(); });
      if (inAll) have.push(s);
      if (it.sof.some(function (x) { return x.toUpperCase().split(/[ \/]/)[0] === s.toUpperCase(); })) sof = true;
    });
    return { ok: have.length > 0, sof: sof, sizes: have };
  }

  function run(q, opt) {
    opt = opt || {};
    var P = parse(q), phrase = P.terms.map(function (t) { return t.w; }).join(' ');
    var res = [], i;
    var hasQuery = P.terms.length > 0;
    for (i = 0; i < items.length; i++) {
      var it = items[i], ok = true;
      for (var k = 0; k < P.terms.length; k++) if (!termOk(it, P.terms[k])) { ok = false; break; }
      if (!ok) continue;
      var sz = sizeHit(it, P);
      if ((P.sizes.length || P.cloth.length) && !sz.ok) continue;
      if (P.sofort && !(sz.sof && (P.sizes.length || P.cloth.length ? true : it.sof.length))) continue;
      if (P.max != null && it.r[4] > P.max) continue;
      var s = 0;
      if (hasQuery) {
        if (it.t.indexOf(phrase) === 0) s += 12; else if (it.t.indexOf(phrase) > -1) s += 6;
        if (it.v.indexOf(P.terms[0].w) === 0) s += 4;
      }
      if (sz.sof) s += 14; else if (it.sof.length) s += 8;
      if (it.r[9]) s += 4;
      if (it.r[8] && !P.kids) s -= 22;
      s -= it.ntok * 0.6;
      res.push({ it: it, s: s, sz: sz });
    }
    res.sort(function (a, b) { return b.s - a.s || a.it.r[4] - b.it.r[4]; });
    var out = { P: P, list: res, total: res.length, relaxed: null };
    if (!res.length && P.terms.length > 1 && !opt.noRelax) {
      /* nichts exakt: vom Ende her Wörter weglassen */
      for (var cut = P.terms.length - 1; cut >= 1; cut--) {
        var sub = P.terms.slice(0, cut).map(function (t) { return t.w; }).join(' ');
        var dropped = P.terms.slice(cut).map(function (t) { return t.orig; });
        var extra = (P.sizes.concat(P.cloth)).join(' ') + (P.sofort ? ' sofort' : '') + (P.max != null ? ' bis ' + P.max : '');
        var r2 = run(sub + ' ' + extra, { noRelax: true });
        if (r2.total) { out.relaxed = { q: sub, dropped: dropped, res: r2 }; break; }
      }
      if (!out.relaxed) {
        var first = P.terms[0].w, r3 = run(first, { noRelax: true });
        if (r3.total) out.relaxed = { q: first, dropped: P.terms.slice(1).map(function (t) { return t.orig; }), res: r3 };
      }
    }
    return out;
  }

  function topBrands(list, n) {
    var c = Object.create(null), nm = Object.create(null);
    list.slice(0, 300).forEach(function (x) { c[x.it.v] = (c[x.it.v] || 0) + 1; nm[x.it.v] = x.it.r[2]; });
    return Object.keys(c).sort(function (a, b) { return c[b] - c[a]; }).slice(0, n).map(function (k) { return { name: nm[k], n: c[k] }; });
  }
  function suggestBrands(q, n) {
    var w = norm(q).split(' ').pop(); if (!w || w.length < 2) return [];
    return brands.filter(function (b) { return b.key.indexOf(w) === 0 || b.key.split(' ').some(function (x) { return x.indexOf(w) === 0; }); }).slice(0, n);
  }
  function hl(text, P) {
    var esc = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;');
    var ws = []; P.terms.forEach(function (t) {
      ws.push(t.w); if (t.orig !== t.w) ws.push(t.orig);
      (t.alts || []).forEach(function (a) { a.forEach(function (x) { if (x.length > 1) ws.push(x); }); });
    });
    ws = ws.filter(function (w) { return w.length > 1; });
    if (!ws.length) return esc;
    var re = new RegExp('(^|[^a-z0-9äöüß])(' + ws.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
    return esc.replace(re, function (m, a, b) { return a + '<b>' + b + '</b>'; });
  }

  root.Engine = { norm: norm, build: build, parse: parse, run: run, topBrands: topBrands, suggestBrands: suggestBrands, hl: hl,
    get items() { return items; }, get brands() { return brands; }, get ready() { return ready; } };
  if (typeof module !== 'undefined') module.exports = root.Engine;
})(typeof window !== 'undefined' ? window : globalThis);
